export default __webpack_public_path__ + "static/media/health_check_male_En.abd5d5e4.webp";